import { safeWindow } from '@sky-distribution/gp-onboarding-shared-utils';
import { useContext, useMemo } from 'react';
import { XRouterContext } from './XRouter';

export interface UseLocationMethods {
  pathname: string;
}

export const useLocation = (): UseLocationMethods => {
  const { basename, location } = useContext(XRouterContext);

  const browserPathName = useMemo(
    () => location ?? safeWindow().location?.pathname ?? basename,
    [location, basename],
  );

  const pathname = browserPathName.replace(basename, '') || '/';

  return { pathname };
};
